export const models_input_example = {
  'converted_file.ksplat': {
    path_url: 'https://dmaqfaypuxogbmrbldfx.supabase.co/storage/v1/object/public/models/converted_file.ksplat',
    normal: {
      viewer_options: {
        cameraUp: [0, -1, 0],
        initialCameraPosition: [1, -1.25, 1],
        initialCameraLookAt: [0, -1, 0],
      },
    },
    ar: {
      splat_scene_options: {
        rotation: {
          vFrom: [0.01933, -0.7583, -0.65161],
          vTo: [0, 1, 0],
        },
        position: [0, 0, 0],
      },
    },
  },
  'bonsai_high.ksplat': {
    path_url: 'https://dmaqfaypuxogbmrbldfx.supabase.co/storage/v1/object/public/models/bonsai_high.ksplat',
    normal: {
      viewer_options: {
        cameraUp: [0.01933, -0.7583, -0.65161],
        initialCameraPosition: [1.54163, 2.68515, -6.37228],
        initialCameraLookAt: [0.45622, 1.95338, 1.51278],
      },
    },
    ar: {
      splat_scene_options: {
        rotation: {
          vFrom: [0.01933, -0.7583, -0.65161],
          vTo: [0, 1, 0],
        },
        position: [0, 0, 0],
      },
    },
  },
}
